import { IChildProp } from "@intelligence/components/Form/type";

const COMPANIES_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'metrics',
    enumTargetType: 'downloadMainCategory',
    type: 'mutipleSelect',
    condition: 'additionalFields:businessType:companies-revenue',
    children: [{
      isDefault: true,
      enumKey: 'mobileRevenue_mobileMetrics',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'pcDigitalRevenue_pcMetrics_split',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'consoleDigitalRevenue_consoleMetrics_split',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'pcPhysicalRevenue_pcMetrics_split',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'consolePhysicalRevenue_consoleMetrics_split',
      enumTargetType: 'metric',
    }],
  },
  {
    enumKey: 'basicInformationOptional',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasGamesOwned',
      enumTargetType: 'downloadBasicInfo',
      isDefault: true,
    }, {
      enumKey: 'hasIPOStatus',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasHeadquaters',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
        msgKey: 'dbi_info_companies_download_modal_time_settings',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }, {
      label: 'Revenue Range Settings',
      labelKey: 'dbi_revenue_range_unit_setting',
      value: 'revenueRangeSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

export default {
  companies: COMPANIES_DOWNLOAD_SET,
};
